<template>
  <div v-cloak class="crowdfunding bg-round bg-fff hh">
    <!-- 中间内容 -->
    <div class="container o-h pa-b-40">
      <div class="ma-t-30"><Bread :list="breadList" /></div>
      <div class="flex search ma-t-30">
        <div class="width30">
          <el-input
            v-model="name"
            placeholder="名称/发起方"
            class="b-r-15"
          ></el-input>
        </div>
        <div class="select-input" v-if="categoryList && categoryList.length>0">
          <el-dropdown @command="categoryid=$event;getList('refresh')">
            <span class="el-dropdown-link">
              {{ categoryList.find(it=>it.Id==categoryid).Name }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="item.Id" v-for="(item,index) in categoryList" :key="index">{{ item.Name }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="select-input">
          <el-dropdown @command="status=$event;getList('refresh')">
            <span class="el-dropdown-link">
              {{ statusList.find(it=>it.Id==status).Name }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="item.Id" v-for="(item,index) in statusList" :key="index">{{ item.Name }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="select-input">
          <el-dropdown @command="sort=$event;getList('refresh')">
            <span class="el-dropdown-link">
              {{ sortList.find(it=>it.Id==sort).Name }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="item.Id" v-for="(item,index) in sortList" :key="index">{{ item.Name }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="">
            <div class="b-r-30 pa-lr-20 pa-tb-10 bg-fb004d c-fff ma-l-40 c-p" @click="getList('refresh')">搜索</div>
        </div>
      </div>
      <div class="ma-t-30">
        <div class="flex f-wrap">
          <div
            v-for="(item, index) in dataList"
            :key="index"
            @click="toDetail(item.Id)"
            class="flex width50 ma-b-20 c-pointer"
          >
            <img :src="item.Cover" alt="" srcset="" width="200" height="300" class="img_cover b-3-red" />
            <div class="pa-10 flex flex-direction f-between flex1">
              <div class="font-bold t-omit-1 fon-20" :title="item.Name">
                {{ item.Name }}
              </div>
              <div class="t-omit-3">
                {{ item.Summary }}
              </div>
              <div class="c-red font-bold">
                发起方：{{ item.Initiator }}
              </div>
              <div>
                <div class="flex f-between ma-t-10">
                <div class="c-red font-bold">￥{{ item.Amount }}</div>
                <div>{{ getProgress(item) }}</div>
              </div>
              <div class="progress-box ma-t-5">
                <div
                  class="progress-line"
                  :style="{ width: getProgress(item) }"
                ></div>
              </div>
              <div class="fon-15 ma-t-5">{{ item.PayCount }}支持者</div>
              </div>
            </div>
          </div>
        </div>
        <Empty :isShow="!dataList.length"></Empty>
      </div>

      <div class="fy">
        <el-pagination
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page.sync="pageIndex"
          :page-size="16"
          layout="prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
::v-deep.search .el-input__inner {
  border-radius: 50px;
  border: 1px solid #fb004d;
}
.search .select-input{
    width: 202px;
    min-height: 40px;
    border: 1px solid #fb004d;
    border-radius: 50px;
    text-align: center;
    line-height: 40px;
    margin-left: 20px;
}
/* 大屏 宽度大于768 */
.b-3-red{
  border: 3px solid #fb004d;
}
  .o-h {
    overflow: hidden;
  }

  body {
    background: #f5f7fa;
  }

  .container {
    padding-left: 30px;
    padding-right: 30px;
    // background: #fff;
    box-sizing: border-box;
  }

  .swiper {
    width: 100%;
    height: 314px;
    background-image: url(../../img/cf-bg.png);
    background-size: cover;
    background-position: bottom;
    position: relative;
  }

  

  .progress-box {
    width: 100%;
    height: 10px;
    background: rgb(219, 219, 219);
    border-radius: 5px;

    .progress-line {
      height: 100%;
      background: red;
      border-radius: 5px;
    }
  }
  
</style>
<script>
import { getCrowdFundingList,getCrowdFundingCategoryList } from "../../api.js";
import Bread from "../../components/Bread.vue";

// studycollect
export default {
  name: "crowdfunding",
  components: { Bread },
  data() {
    return {
      activeName: "0",
      kinds: [{ Id: "0", Name: "全部" }],
      totals: 0, //一个分类下的总条数
      pageIndex: 1,
      dataList: [],
      breadList: [{ name: "项目发现", path: "/crowd/index" }],
      status:0,//众筹状态；0全部；1：众筹中；2：众筹成功
      sort:0,//排序：0：最新上线；1：最多支持者；2：金额最高
      sortList:[
        {Name:'最新上线',Id:'0'},
        {Name:'最多支持者',Id:'1'},
        {Name:'金额最高',Id:'2'}
      ],
      statusList:[
        {Name:'全部状态',Id:'0'},
        {Name:'众筹中',Id:'1'},
        {Name:'众筹成功',Id:'2'}
      ],
      categoryList:[{Id:0,Name:'全部分类'}],
      categoryid:0,
      name:'',//搜索名称
    };
  },

  created() {
    // console.log("created----");
    this.getList();
    this.loadData()
  },

  // 其他页面进来时更新初始数据
  activated() {
    // console.log("909090------");
  },

  methods: {
    //获取众筹分类
    loadData(){
      getCrowdFundingCategoryList().then(res=>{
        this.categoryList=this.categoryList.concat(res.data.Data.List)
      })
    },
    //获取进度
    getProgress(item) {
      return ((item.GetAmount * 100) / item.Amount).toFixed(2) + "%";
    },
    getList(type) {
      if(type=='refresh'){
            this.pageIndex=1
      }
      let token = localStorage.getItem("AccessToken");
      let data = {
        token: token,
        source: "web",
        pageIndex: this.pageIndex,
        status:this.status,
        sort:this.sort,
        name:this.name,
        categoryid:this.categoryid,
        pageSize: 12,
      };
      // console.log(data);
      getCrowdFundingList(data).then((res) => {
        if (res.data.Code == 0) {
          this.dataList = res.data.Data.List;
          this.totals = res.data.Data.TotalCount;
        }
      });
    },
    toDetail(id = 1) {
      //  this.$router.push({
      //   path: "/Img",
      //   query: { id: id },
      // });
      // this.$router.push({
      //     path: "/crowd/detail",
      //     query: { id: id },
      // });
      window.open("/crowd/detail?id=" + id);
    },

    //点击切换种类
    handleClick() {
      // console.log(tab);
      this.pageIndex = 0;
      this.getList();
    },

    // 当前页改变时触发
    handleCurrentChange(e) {
      this.pageIndex = e - 1;
      this.getList();
    },
  },
};
</script>
